<template>
  <div>Mudancas</div>
</template>

<script>
export default {};
</script>

<style>
</style>